import type React from 'react';
import type { ShiftFlowValue } from '../useShiftFlow';
import { ShiftApproverPicker } from './ShiftApproverPicker';
import { ShiftApproverPin } from './ShiftApproverPin';

/**
 * The discrepancy co-sign step (render-only). Two sub-views: the approver
 * picker until an admin is chosen (`ShiftApproverPicker`), then that admin's
 * PIN (`ShiftApproverPin`). Both are keyboard-operable (bos-seller#61).
 */
export const ShiftApproverStep: React.FC<ShiftFlowValue> = ({
    approvers,
    approversLoading,
    approversError,
    focusApproverId,
    selectedApprover,
    selectApprover,
    approverPin,
    onPinDigit,
    onPinBackspace,
    onPinEscape,
    approved,
    approvalErrorMessage,
    isApprovalHeld,
    isVerifying,
}) =>
    selectedApprover ? (
        <ShiftApproverPin
            approvalErrorMessage={approvalErrorMessage}
            approved={approved}
            approver={selectedApprover}
            approverPin={approverPin}
            isApprovalHeld={isApprovalHeld}
            isVerifying={isVerifying}
            onPinBackspace={onPinBackspace}
            onPinDigit={onPinDigit}
            onPinEscape={onPinEscape}
        />
    ) : (
        <ShiftApproverPicker
            approvers={approvers}
            approversError={approversError}
            approversLoading={approversLoading}
            focusApproverId={focusApproverId}
            selectApprover={selectApprover}
        />
    );
